import { module } from 'modujs';
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin.js";
import { gsap } from "gsap";

export default class extends module {
    constructor(m) {
        super(m);

        this.onFontsLoadedBind = this.onFontsLoaded.bind(this);
    }

    init() {
        gsap.registerPlugin(DrawSVGPlugin);
        gsap.config({
            nullTargetWarn: false
        });

        this.$buttons = this.el.querySelectorAll('[data-features-button]');

        this.$items = this.el.querySelectorAll('[data-features-item]');

        this.$path = this.el.querySelectorAll('path');

        //set path to 0
        gsap.set(this.$path, {
            drawSVG: 0
        });

        this.bindEvents();

        if (window.isFontsLoaded) {
            this.onFontsLoaded();
        }
    }

    bindEvents() {
        window.addEventListener('fontsLoaded', this.onFontsLoadedBind);
    }

    unbindEvents() {
        window.removeEventListener('fontsLoaded', this.onFontsLoadedBind);
    }

    onFontsLoaded() {
        this.$buttons[0].classList.add('is-active');
        this.$items[0].classList.add('is-active');

        gsap.to(this.$path[0], {
            duration: 1,
            drawSVG: "100%",
            delay: 0,
            ease: "power2.out"
        });

        for (let i = 0; i < this.$buttons.length; i++) {
            this.$buttons[i].addEventListener('click', () => {
                for (let j = 0; j < this.$buttons.length; j++) {
                    this.$buttons[j].classList.remove('is-active');
                    this.$items[j].classList.remove('is-active');
                    gsap.to(this.$path[j], {
                        duration: 1,
                        drawSVG: 0,
                        delay: 0,
                        ease: "power2.out"
                    });
                }

                this.$buttons[i].classList.add('is-active');
                this.$items[i].classList.add('is-active');
                gsap.to(this.$path[i], {
                    duration: 1,
                    drawSVG: "100%",
                    delay: 0,
                    ease: "power2.out"
                });
            });
        }
    }

    destroy() {
        super.destroy();
        this.unbindEvents();
    }
}
